import { Component } from '@angular/core'
import { Location } from '@angular/common'
import { Router, NavigationStart, NavigationEnd } from '@angular/router'
import { LoadingService } from './service/loading/loading.service'
import { BackgroundLoadingService } from './content/organizations/edit-hotel/revenue/service/background-loading.service'
import { Observable } from 'rxjs'

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent {
  loading$: Observable<boolean>
  title = 'AgAppWebSatellite'
  constructor(
    router: Router,
    loadingService: LoadingService,
    public backgroundLoadingService: BackgroundLoadingService,
  ) {
    router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        loadingService.loadingMap.clear()
      }
    })
    this.loading$ = this.backgroundLoadingService.loading$
    this.loading$.subscribe((isLoading) => {
      if (isLoading) {
        document.body.style.overflow = 'hidden'
      } else {
        document.body.style.overflow = 'auto'
      }
    })
  }
}
